module.exports = __webpack_public_path__ + "img/Hero-mobile@3x.7369eed9.png";